import React, { PureComponent } from 'react';
import axios from 'axios';
import { Row, Col, Glyphicon } from 'react-bootstrap';
import Pagination from "react-js-pagination";
import LinksResult from './linksResult';
import appConstant from '../../../../constants/app';

class LinksList extends PureComponent {
  state = {
    links: [],
    totalItems: null,
    body: '',
    activePage: 1,
    itemsCountPerPage: 15,
    pageRangeDisplayed: 5,
    isLoaderOpened: false,
    showPagination: false,
  }

  componentDidMount () {
    this.fetch(1);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.keyword !== this.props.keyword) {
      this.setState({
        activePage: 1,
      });
      this.props.showLinksResults();
      this.fetchSearch(this.props.keyword, 1);
    }
  }
  
  fetch = (page) => {
    this.setState({ isLoaderOpened: true });

    let url = `${appConstant.API_URL}/link?page=${page}`;
    axios.get(url)
      .then(res => {
        const totalItems = res.data.totalItems;
        const links = res.data.links;
        const showPagination = (totalItems > this.state.itemsCountPerPage);
        this.setState({
          links,
          totalItems,
          showPagination,
        });

        this.setState({ isLoaderOpened: false });
      }).catch(err => {
        console.log(err);
      });
  }

  fetchSearch = (key, page) => {
    let url = `${appConstant.API_URL}/link/search?key=${key}&from=front&page=${page}`;
    axios.get(url)
      .then(res => {
        this.setState({links: []});
        const totalItems = res.data.totalItems;
        const links = res.data.links;
        const showPagination = (totalItems > this.state.itemsCountPerPage);
        this.setState({
          links,
          totalItems,
          showPagination,
        });
      }).catch(err => {
        console.log(err);
        const links = [];
        const totalItems = 0;
        this.setState({
          links,
          totalItems,
        });
      });
  }

  onAccept = () => {
    this.fetch(1);
  }

  handlePageChange = (pageNumber) => {
    this.setState({activePage: pageNumber});

    if(this.props.keyword) {
      this.fetchSearch(this.props.keyword, pageNumber);
    } else {
      this.fetch(pageNumber);
    }
  }

  render () {
    const {
      links,
      totalItems,
      itemsCountPerPage,
      pageRangeDisplayed,
      isLoaderOpened,
      showPagination,
    } = this.state;

    let link = "https://www.google.com/search?q=inurl:fiu.edu " + this.props.keyword;

    return (
      <div>
      {
      this.props.showList
      ?
      <div>
        <Row>
          <Col className="results-container" sm={12}>
            <label
              className="lbl-total">
              Total Results: {totalItems}
            </label>
            {
              isLoaderOpened
              ? <p> Loading... </p>
              :
              <LinksResult
                links={links}
              />
            }
          </Col>
        </Row>
        {
          showPagination
          ?
          <Row>
            <Col
              className="pagination-container"
              sm={12}>
              <Pagination
                activePage={this.state.activePage}
                totalItemsCount={totalItems}
                itemsCountPerPage={itemsCountPerPage}
                pageRangeDisplayed={pageRangeDisplayed}
                onChange={this.handlePageChange}
                hideNavigation={true}
                hideFirstLastPages={true}
              />
            </Col>
          </Row>
          :
          <Row>
          </Row>
        }

        { this.props.keyword.length > 2 && <div className="google-search">
            <a target="_blank" href={link} rel="noopener noreferrer">
              <Glyphicon glyph="search" className="icon" />
              Search for <span>{this.props.keyword}</span> on Google
            </a>
          </div>
        }
      </div>
      :
      <div></div>
      }
      </div>
    );
  }
}

export default LinksList;



// WEBPACK FOOTER //
// ./src/app/screens/landing/links/linksList.js